import React, { memo } from 'react'
import tw from 'twin.macro'
import { CircularProgress, LinearProgress, Typography } from '@mui/material'
import { invoiceActionLabels } from 'src/constants/invoice/constants'
import { InvoiceActionVerb } from 'src/constants/invoice/enums'

interface Props {
  verb: InvoiceActionVerb
  completed: number
  total: number
}

const InvoiceActionProgressStepComponent = ({ verb, completed, total }: Props) => {
  // A one-invoice run has no meaningful progress to show — a bar that jumps 0→100 in one step
  // just flashes. It gets a spinner instead; multi-invoice runs get the real determinate bar.
  if (total <= 1) {
    return (
      <div
        data-testid="invoice-action-progress"
        css={tw`flex flex-col items-center justify-center gap-3 py-6`}
      >
        <CircularProgress size={28} />
        <Typography variant="body2" css={tw`text-shades-500`}>
          {invoiceActionLabels[verb]}…
        </Typography>
      </div>
    )
  }

  const percentComplete = Math.round((completed / total) * 100)

  return (
    <div data-testid="invoice-action-progress" css={tw`flex flex-col gap-2 py-4`}>
      <LinearProgress variant="determinate" value={percentComplete} />
      <div css={tw`flex flex-row justify-between`}>
        <Typography variant="body2" css={tw`text-shades-500`}>
          {completed < total ? `Processing invoice ${completed + 1}…` : 'Finishing up…'}
        </Typography>
        <Typography variant="body2" css={tw`text-shades-500`}>
          {completed} of {total}
        </Typography>
      </div>
    </div>
  )
}

export const InvoiceActionProgressStep = memo(InvoiceActionProgressStepComponent)
